var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.712 4.074l-2.794-2.8.917-.917a1.222 1.222 0 01.928-.36 1.3 1.3 0 01.928.382l.939.939a1.32 1.32 0 010 1.835zM.655 16A.635.635 0 010 15.345v-1.878a.642.642 0 01.044-.24.666.666 0 01.153-.218L11 2.196l2.794 2.8L2.99 15.804a.665.665 0 01-.218.153.641.641 0 01-.24.044z",
    opacity: 0.6
  })));
}
export default SvgEditEmail;